import { hydrateBookingDraft } from '@/lib/bookingPersistence';

/**
 * Loads the booking flow's page for its route, and in the app also the
 * booking draft it reads.
 *
 * The flow reads its draft synchronously, in render-phase initialisers. In the
 * app the draft lives in the async secure store and is read from an in-memory
 * copy, so the route resolves only once that copy has loaded; mounting earlier
 * would restore nothing and the client's half-finished booking would reset
 * (M4, mobile assessment §R.66). On the web hydrateBookingDraft resolves at
 * once.
 */
export function loadBookingFlowPage() {
  return Promise.all([import('@/pages/BookingFlow'), hydrateBookingDraft()]).then(([page]) => page);
}
